<button type="button" class="btn btn-dark btn-sm" mdbRipple (click)="generateMore($event,true)" cvaAuthPermCheck
    [moduleName]='moduleName' [permissionType]='permissionType' [actionType]='"disable"' [disabled]="disabled">
    {{name }}
</button>